import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import CircularProgress from "@mui/material/CircularProgress";
import PrintIcon from "@mui/icons-material/PrintOutlined";
import { QRCodeSVG } from "qrcode.react";

import PageHeader from "components/PageHeader";
import DataTable from "components/DataTable";

import useQrCodeData from "layouts/tables/data/qrCodeData";

function QrCodes() {
  const {
    columns,
    rows,
    isLoading,
    error,
    qrModalOpen,
    setQrModalOpen,
    qrMember,
    qrToken,
    isLoadingQr,
    handlePrint,
  } = useQrCodeData();

  if (isLoading) {
    return <Typography sx={{ py: 6 }}>Loading members...</Typography>;
  }

  if (error) {
    return (
      <Typography color="error" sx={{ py: 6 }}>
        Error: {error}
      </Typography>
    );
  }

  return (
    <Box>
      <PageHeader
        title="Member QR Codes"
        subtitle="Generate and print a personal check-in QR badge for each member. Ushers scan it at the QR Check-In station."
      />

      <Card>
        <DataTable
          table={{ columns, rows }}
          isSorted
          entriesPerPage={{ defaultValue: 10, entries: [5, 10, 15, 20, 25] }}
          showTotalEntries
          canSearch
          searchLabel="Search members..."
        />
      </Card>

      <Dialog open={qrModalOpen} onClose={() => setQrModalOpen(false)} maxWidth="xs" fullWidth>
        <DialogContent>
          <Box sx={{ textAlign: "center", py: 2 }}>
            {isLoadingQr ? (
              <CircularProgress size={28} />
            ) : qrToken ? (
              <>
                <Typography variant="h6" fontWeight={700} mb={0.5}>
                  {qrMember?.first_name} {qrMember?.surname}
                </Typography>
                <Typography variant="caption" color="text.secondary" display="block" mb={2}>
                  {qrMember?.memberID}
                </Typography>
                <Box sx={{ display: "inline-block", p: 2, bgcolor: "#fff", borderRadius: 2 }}>
                  <QRCodeSVG value={qrToken} size={200} />
                </Box>
              </>
            ) : (
              <Typography color="error">Could not load QR code.</Typography>
            )}
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setQrModalOpen(false)}>Close</Button>
          <Button
            variant="contained"
            startIcon={<PrintIcon />}
            onClick={handlePrint}
            disabled={!qrToken}
          >
            Print
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}

export default QrCodes;
